export const isOptionSelected = (option, selectedOptions) => {
  return Array.isArray(option)
      ? option.every(o => (selectedOptions || []).includes(o))
      : (selectedOptions || []).includes(option);
}
